import React, { Suspense } from 'react';
import { Title, Wrapper, Content } from './empty-state.styled';
export var EmptyState = function EmptyState(_ref) {
  var title = _ref.title,
    content = _ref.content,
    Image = _ref.Image;
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Image, null), /*#__PURE__*/React.createElement(Title, null, title), /*#__PURE__*/React.createElement(Content, null, content)));
};